import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
  standalone: false,
})
export class MonthPickerComponent implements OnInit {
  constructor() {}

  @Input()
  multiple: boolean;
  @Input()
  showAllEntry: boolean;
  @Output()
  selectedValueChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  selectedYearChanged: EventEmitter<number> = new EventEmitter<number>();
  preselectedYear: number;
  preselectedMonth: number;

  values: string[] = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ];

  years: number[] = [2025, 2026];
  ngOnInit() {
    const d = new Date();
    this.preselectedYear = d.getFullYear();
    this.preselectedMonth = d.getMonth();
  }
}
